import React, { useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";
const FaNewspaper = require("react-icons/fa").FaNewspaper;

interface ReplyModalProps {
  isOpen: boolean;
  onClose: () => void;
  aspirasiId: number | null;
  onSuccess: () => void;
}

const ReplyModal: React.FC<ReplyModalProps> = ({ isOpen, onClose, aspirasiId, onSuccess }) => {
  const [balasan, setBalasan] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  if (!isOpen || aspirasiId === null) return null;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      const token = Cookies.get("token");
      await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/api/aspirasi/${aspirasiId}/reply`,
        { balasan },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      onSuccess();
      onClose();
      setBalasan("");
      setSuccess(true);
    } catch (err) {
      console.error("Gagal mengirim balasan:", err);
      alert("Gagal mengirim balasan, coba lagi!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-6">
        <h2 className="text-lg font-bold mb-4">Balas Aspirasi</h2>
        <form onSubmit={handleSubmit}>
          <textarea value={balasan} onChange={(e) => setBalasan(e.target.value)} className="w-full border rounded p-2 mb-4" rows={4} placeholder="Tulis balasan..." required />
          <div className="flex justify-end gap-2">
            <button type="button" onClick={onClose} className="px-4 py-2 rounded bg-gray-300 hover:bg-gray-400">
              Batal
            </button>
            <button type="submit" disabled={loading} className="px-4 py-2 rounded bg-primary text-white hover:bg-blue-700 disabled:opacity-50">
              {loading ? "Mengirim..." : "Kirim Balasan"}
            </button>
          </div>
        </form>
      </div>

      {success && (
        <div className="fixed inset-0 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg flex flex-col items-center">
            <FaNewspaper className="w-12 h-12 text-gray-600-500 mb-2" />
            <p className="font-semibold">Berhasil membalas aspirasi!</p>
            <button onClick={() => setSuccess(false)} className="mt-4 px-4 py-2 bg-primary text-white rounded hover:bg-blue-700">
              Tutup
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReplyModal;
